import axios from "axios";
import Config from "../globals/Config";

const PORT: string | undefined = Config.port;
const HOST: string | undefined = Config.host;
// Create an Axios instance
const apiClient = axios.create({
	baseURL: `${HOST}:${PORT}`, //DEPLOYMENT WARNING!
	withCredentials: true,
});

// Add a response interceptor
apiClient.interceptors.response.use(
	(response) => response, // If response is successful, just return it
	async (error) => {
		const originalRequest = error.config;

		// Handle 403 Forbidden response
		if (error.response.status === 403) {
			// Redirect to login page

			window.location.href = "/login";
			alert("Access denied. Redirecting to login...");

			return Promise.reject(error);
		}

		return Promise.reject(error);
	}
);

export default apiClient;
